<template>
  <div :class="['ms-form', 'techproject-developer-form', { purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onSubmit">
      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-user-gear" aria-hidden="true" />Роль в ремонте</h3>
        <div class="section-subtitle">Определяет, в каких списках выбора будет виден контрагент</div>
        <div class="role-cards">
          <label :class="['role-card', { 'role-card_active': formData.is_design }]">
            <q-checkbox v-model="formData.is_design" color="primary" />
            <span class="material-icons">architecture</span>
            <div>
              <div class="role-card__title">Проектирование</div>
              <div class="role-card__desc">Разработчик тех. проекта</div>
            </div>
          </label>
          <label :class="['role-card', { 'role-card_active': formData.is_support }]">
            <q-checkbox v-model="formData.is_support" color="primary" />
            <span class="material-icons">support_agent</span>
            <div>
              <div class="role-card__title">Сопровождение</div>
              <div class="role-card__desc">Контрагент по сопровождению</div>
            </div>
          </label>
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-building" aria-hidden="true" />Основные данные</h3>
        <div class="ms-form-grid">
          <CustomInput label="Название" type="text" :required="true" :value="this.formData.techproject_developer_name"
            @change_input="(value) => onChange('techproject_developer_name', value)" />
          <CustomInput label="Юридическое наименование" type="text" :value="this.formData.legal_name"
            @change_input="(value) => onChange('legal_name', value)" />
          <CustomInput label="БИН" type="text" :required="true" :value="this.formData.bin"
            @change_input="(value) => onChange('bin', value)" />
          <CustomInput label="Полное ФИО Директора" type="text" :value="this.formData.director_fio_myspace"
            @change_input="(value) => onChange('director_fio', value)" />
          <CustomSelect :options="cityOptions" label="Город" :required="true" optionValueKey="city_id"
            optionLabelKey="city_name" :value="this.formData.city_id || ''"
            @change="(value) => onChange('city_id', value)" />
          <CustomSelect :options="contragentTypeOptions" label="Тип контрагента" optionValueKey="contragent_type_id"
            optionLabelKey="contragent_type_name" :value="this.formData.contragent_type_id || ''"
            @change="(value) => onChange('contragent_type_id', value)" />
          <CustomInput class="ms-form-wide" label="Адрес" type="text" :required="true" :value="this.formData.address"
            @change_input="(value) => onChange('address', value)" />
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-address-card" aria-hidden="true" />Контакты и реквизиты</h3>
        <div class="ms-form-grid">
          <CustomInput label="Телефон" type="text" :value="this.formData.phone"
            @change_input="(value) => onChange('phone', value)" />
          <CustomInput label="Email" type="email" :value="this.formData.email"
            @change_input="(value) => onChange('email', value)" />
          <CustomInput label="БИК" type="text" :value="this.formData.bik"
            @change_input="(value) => onChange('bik', value)" />
          <CustomInput label="ИИК" type="text" :value="this.formData.iik"
            @change_input="(value) => onChange('iik', value)" />
          <CustomInput label="КБе" type="number" :value="this.formData.kbe"
            @change_input="(value) => onChange('kbe', value)" />
          <CustomInput label="ГУИД" type="text" :value="this.formData.guid"
            @change_input="(value) => onChange('guid', value)" />
          <CustomInput class="ms-form-wide" label="Наименование банка" type="text" :value="this.formData.bank_name"
            @change_input="(value) => onChange('bank_name', value)" />
          <CustomInput class="ms-form-wide" label="Текст для договора" type="textarea" :value="this.formData.contract_text"
            @change_input="(value) => onChange('contract_text', value)" />
        </div>
      </section>

      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomCheckbox from "@/components/form/CustomCheckbox";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import { getCity, getContragentType } from "@/views/handbook/techprojectDevelopers/services";

export default {
  name: "add-handbook-techproject-developer",
  components: { CustomCheckbox, CustomModalFooter, CustomInput, CustomSelect },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        techproject_developer_name: this.data?.body?.techproject_developer_name || '',
        director_fio: this.data?.body?.director_fio || '',
        guid: this.data?.body?.guid || '',
        bin: this.data?.body?.bin || '',
        address: this.data?.body?.address || '',
        city_id: this.data?.body?.city_id || '',
        contragent_type_id: this.data?.body?.contragent_type_id || '',
        iik: this.data?.body?.iik || '',
        bank_name: this.data?.body?.bank_name || '',
        bik: this.data?.body?.bik || '',
        kbe: this.data?.body?.kbe || '',
        contract_text: this.data?.body?.contract_text || '',
        phone: this.data?.body?.phone || '',
        email: this.data?.body?.email || '',
        is_design: this.data?.body ? this.data?.body?.is_design !== false : true,
        is_support: this.data?.body ? this.data?.body?.is_support !== false : true,
      },
      cityOptions: [],  
      contragentTypeOptions: [], 
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
    async fetchCities() {
      this.cityOptions = await getCity();
    },
    async fetchContragentType() {
      this.contragentTypeOptions = await getContragentType();
    },
  },
  mounted() {
    this.fetchCities();
    this.$watch('cityOptions', (newOptions) => {
      if (newOptions.length && !this.formData.city_id) {
        this.formData.city_id = newOptions[0].city_id;
      }
    });
    this.fetchContragentType();
  }
}
</script>

<style scoped lang="scss">
// Блоки и сетка — общие (ms-form-* в theme.scss)
.section-subtitle {
  color: var(--ms-text-secondary);
  font-size: 12px;
  margin: -6px 0 12px;
}

.role-cards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.role-card {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid var(--ms-border);
  background: var(--ms-surface);
  border-radius: var(--ms-radius-sm);
  padding: 10px;
  cursor: pointer;
  transition: border-color .15s ease, box-shadow .15s ease, background .15s ease;

  .material-icons {
    color: var(--ms-muted);
    font-size: 24px;
  }

  &_active {
    border-color: var(--ms-primary);
    background: var(--ms-primary-50);

    .material-icons {
      color: var(--ms-primary);
    }
  }

  &__title {
    font-size: 13px;
    color: var(--ms-text);
    font-weight: 700;
  }

  &__desc {
    font-size: 11px;
    color: var(--ms-text-secondary);
    margin-top: 2px;
  }
}
</style>